var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-input-container",
    [
      _c("label", { attrs: { for: "countries" } }, [_vm._v("Country")]),
      _c(
        "md-select",
        {
          attrs: { id: "countries", multiple: "multiple" },
          on: { selected: _vm.onCountrySelected },
          model: {
            value: _vm.selectedCountries,
            callback: function($$v) {
              _vm.selectedCountries = $$v
            },
            expression: "selectedCountries"
          }
        },
        _vm._l(_vm.countries, function(country) {
          return _c(
            "md-option",
            { key: country.code, attrs: { value: country.code } },
            [_vm._v(_vm._s(country.name))]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be49733c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be49733c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/country/CountrySelector.vue
// module id = 873
// module chunks = 0